module.exports = __webpack_public_path__ + "static/media/completed.82e9870a.png";